import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { TicketOffer } from '../core/ticketOffer';

@Injectable()
export class TicketService {
    private readonly url = `${environment.apiUrl}/transport/ticketOffers`;
    private readonly basePriceSettingUrl = `${environment.apiUrl}/settings/baseTripPrice`;
    private readonly maxBuyTripsCountUrl = `${environment.apiUrl}/settings/maxBuyTripsCount`;

    private jsonContentHeader: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) { }

    get(): Observable<TicketOffer[]> {
        return this.http
            .get(this.url, { headers: this.jsonContentHeader })
            .map(result => this.wrapTicketOffers(result['data']));
    }

    publish(newTicketOfferString): Observable<TicketOffer> {
        return this.http
            .post(this.url, newTicketOfferString, { headers: this.jsonContentHeader })
            .map(result => this.wrapTicketOffer(result['data']));
    }

    update(id, updatedTicketOfferString): Observable<TicketOffer> {
        return this.http
            .put(`${this.url}/${id}`, updatedTicketOfferString, { headers: this.jsonContentHeader })
            .map(result => this.wrapTicketOffer(result['data']));
    }

    remove(id): Observable<boolean> {
        return this.http
            .delete(`${this.url}/${id}`)
            .map(result => {
                return true;
            });
    }

    public getBasePrice(): Observable<any> {
        return this.http
            .get(`${this.basePriceSettingUrl}`)
            .map((result: any) => result.data);
    }

    public updateBasePrice(price: number): Observable<any> {
        return this.http
            .put(`${this.basePriceSettingUrl}`, price)
            .map((result: any) => result.data);
    }

    public getMaxBuyTripsCount(): Observable<any> {
        return this.http
            .get(`${this.maxBuyTripsCountUrl}`)
            .map((result: any) => result.data);
    }

    public updateMaxBuyTripsCount(count: number): Observable<any> {
        return this.http
            .put(`${this.maxBuyTripsCountUrl}`, count)
            .map((result: any) => result.data);
    }

    private wrapTicketOffers(raw: any[]): TicketOffer[] {
        const ticketOffers = [];

        if (raw && raw.length && raw.length > 0) {
            for (const r of raw) {
                ticketOffers.push(this.wrapTicketOffer(r));
            }
        }

        return ticketOffers;
    }
    private wrapTicketOffer(raw: any): TicketOffer {
        const ticketOffer = new TicketOffer();

        ticketOffer.id = raw.id;
        ticketOffer.minTripsCount = raw.minTripsCount;
        ticketOffer.maxTripsCount = raw.maxTripsCount;
        ticketOffer.bonusTripsCount = raw.bonusTripsCount;
        ticketOffer.discount = raw.discount;
        ticketOffer.cost = raw.cost;
        ticketOffer.price = raw.price;

        return ticketOffer;
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/providers/ticket.service.ts